import { Outlet } from 'react-router'

export function Root() {
	return (
		<>
			<div className="mb-6 flex gap-4 justify-between items-center">
				<h2 className="text-lg">Statistika</h2>
			</div>
			<div className="grow">
				<Outlet />
			</div>
		</>
	)
}
